import type { CSSObject } from '@emotion/react'
import { Color, FontWeight, Theme, Typography } from '@opallabs/gem'
import { HeadingSize } from './types'

const sizeToTypography = {
  [HeadingSize.xLarge]: Typography.H700,
  [HeadingSize.large]: Typography.H500,
  [HeadingSize.medium]: Typography.H300,
  [HeadingSize.small]: {
    ...Typography.H100,
    // Carried over from old Lapidary gem styles; may no longer be correct.
    lineHeight: '20px',
  },
} as const

export const styles = (size: HeadingSize, theme: Theme): CSSObject => ({
  color: Color[theme].Text.Default,
  ...sizeToTypography[size],
  fontWeight: FontWeight.Medium,
  margin: 0,
})
